import { useEffect, useState } from "react";
import {
  Check,
  Edit,
  MoreHorizontal,
  Plus,
  Search,
  Trash,
  UserPlus,
  Users,
} from "lucide-react";
import { API_HOST } from "../../api_utils";
import { useSelector } from "react-redux";
import { getOrgEmployees } from "../../API/Company-admin/userApi";

export default function TeamCollaboration() {
  const { userInfo } = useSelector((state) => state.userLogin);
  const [employees, setEmployees] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [activeTab, setActiveTab] = useState("members");
  const [showCreateTeamDialog, setShowCreateTeamDialog] = useState(false);

  const handleCreateTeam = () => {
    setShowCreateTeamDialog(false);
    setShowAlert(true);
    setTimeout(() => setShowAlert(false), 3000);
  };

  const getEmployees = async () => {
    try {
      const data = await getOrgEmployees(
        userInfo?.organisation_id,
        userInfo?.token
      );
      setEmployees(data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getEmployees();
  }, [userInfo?.organisation_id]);

  const teams = [
    {
      id: "team1",
      name: "Marketing",
      members: 8,
      lead: "Sarah Johnson",
      projects: 12,
      status: "Active",
    },
    {
      id: "team2",
      name: "Development",
      members: 15,
      lead: "Michael Chen",
      projects: 8,
      status: "Active",
    },
    {
      id: "team3",
      name: "Design",
      members: 6,
      lead: "Emily Rodriguez",
      projects: 10,
      status: "Active",
    },
    {
      id: "team4",
      name: "Sales",
      members: 10,
      lead: "David Kim",
      projects: 5,
      status: "Inactive",
    },
  ];

  const teamMembers = [
    {
      id: "user1",
      name: "Sarah Johnson",
      email: "sarah.j@company.com",
      role: "Team Lead",
      joined: "2022-01-15",
    },
    {
      id: "user2",
      name: "Alex Thompson",
      email: "alex.t@company.com",
      role: "Designer",
      joined: "2022-02-10",
    },
    {
      id: "user3",
      name: "Maria Garcia",
      email: "maria.g@company.com",
      role: "Content Writer",
      joined: "2022-03-05",
    },
    {
      id: "user4",
      name: "James Wilson",
      email: "james.w@company.com",
      role: "SEO Specialist",
      joined: "2022-04-20",
    },
    {
      id: "user5",
      name: "Priya Patel",
      email: "priya.p@company.com",
      role: "Social Media Manager",
      joined: "2022-05-12",
    },
  ];

  return (
    <div className="space-y-6">
      {showAlert && (
        <div className="rounded-lg bg-green-50 p-4 text-green-800">
          <div className="flex">
            <div className="flex-shrink-0">
              <Check className="h-5 w-5" />
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-medium">Success</h3>
              <div className="mt-2 text-sm">
                New team has been created successfully.
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Create Team Dialog */}
      {showCreateTeamDialog && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
          <div className="w-full max-w-md overflow-hidden rounded-lg bg-white shadow-xl">
            <div className="px-6 py-4">
              <h3 className="text-lg font-medium text-gray-900">
                Create New Team
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                Create a new team and add members to collaborate on projects.
              </p>

              <div className="mt-4 space-y-4">
                <div>
                  <label
                    htmlFor="team-name"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Team Name
                  </label>
                  <input
                    type="text"
                    id="team-name"
                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                    placeholder="Enter team name"
                  />
                </div>

                <div>
                  <label
                    htmlFor="team-lead"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Team Lead
                  </label>
                  <input
                    type="text"
                    id="team-lead"
                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                    placeholder="Select team lead"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700">
                    Team Members
                  </label>
                  <div className="mt-1 flex flex-wrap gap-2">
                    <span className="inline-flex items-center rounded-full bg-gray-200 px-2.5 py-0.5 text-sm font-medium text-gray-800">
                      Sarah Johnson
                      <button
                        type="button"
                        className="ml-1.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-gray-400 hover:bg-gray-300 hover:text-gray-500"
                      >
                        <span className="sr-only">Remove</span>
                        <Trash className="h-3 w-3" />
                      </button>
                    </span>
                    <span className="inline-flex items-center rounded-full bg-gray-200 px-2.5 py-0.5 text-sm font-medium text-gray-800">
                      Alex Thompson
                      <button
                        type="button"
                        className="ml-1.5 inline-flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full text-gray-400 hover:bg-gray-300 hover:text-gray-500"
                      >
                        <span className="sr-only">Remove</span>
                        <Trash className="h-3 w-3" />
                      </button>
                    </span>
                    <button
                      type="button"
                      className="inline-flex items-center rounded-full border border-gray-300 bg-white px-2.5 py-0.5 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                    >
                      <Plus className="mr-1 h-3 w-3" />
                      Add Member
                    </button>
                  </div>
                </div>

                <div>
                  <label
                    htmlFor="team-description"
                    className="block text-sm font-medium text-gray-700"
                  >
                    Description
                  </label>
                  <input
                    type="text"
                    id="team-description"
                    className="mt-1 block w-full rounded-md border border-gray-300 px-3 py-2 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
                    placeholder="Enter team description"
                  />
                </div>
              </div>
            </div>
            <div className="flex justify-end bg-gray-50 px-6 py-3">
              <button
                type="button"
                className="mr-2 rounded-md border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 shadow-sm hover:bg-gray-50"
                onClick={() => setShowCreateTeamDialog(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                className="rounded-md bg-red-600 px-4 py-2 text-sm font-medium text-white hover:bg-red-700"
                onClick={handleCreateTeam}
              >
                Create Team
              </button>
            </div>
          </div>
        </div>
      )}

      <div className="flex items-center justify-between">
        <div className="relative w-full max-w-sm">
          <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
            <Search className="h-4 w-4 text-gray-500" />
          </div>
          <input
            type="text"
            placeholder="Search members..."
            className="block w-full rounded-md border border-gray-300 bg-white py-2 pl-10 pr-3 shadow-sm focus:border-red-500 focus:outline-none focus:ring-red-500 sm:text-sm"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
          />
        </div>

        {/* <button
          onClick={() => setShowCreateTeamDialog(true)}
          className="ml-3 inline-flex items-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700"
        >
          <Plus className="mr-2 h-4 w-4" />
          Create Team
        </button> */}
      </div>

      <div>
        <div className="mb-4 border-b border-gray-200">
          <nav className="-mb-px flex space-x-8" aria-label="Tabs">
            {/* <button
              // onClick={() => setActiveTab("teams")}
              className={`flex items-center whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
                activeTab === "teams"
                  ? "border-red-500 text-red-600"
                  : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
              }`}
            >
              <Users className="mr-2 h-4 w-4" />
              Teams
            </button> */}
            <button
              style={
                activeTab === "members" ? { borderBottom: "2px solid" } : {}
              }
              onClick={() => setActiveTab("members")}
              className={`flex items-center whitespace-nowrap border-b-2 px-1 py-4 text-sm font-medium ${
                activeTab === "members"
                  ? "border-red-500 text-red-600"
                  : "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700"
              }`}
            >
              <UserPlus className="mr-2 h-4 w-4" />
              Team Members
            </button>
          </nav>
        </div>

        {activeTab === "teams" && (
          <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="border-b border-gray-200 px-6 py-4">
              <h3 className="text-lg font-semibold text-gray-900">Teams</h3>
              <p className="text-sm text-gray-500">Manage your company teams</p>
            </div>
            <div className="px-6 py-4">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        Team Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        Members
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        Team Lead
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        Projects
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        Status
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {teams?.length ? (
                      <>
                        {teams
                          .filter((team) =>
                            team.name
                              .toLowerCase()
                              .includes(searchTerm.toLowerCase())
                          )
                          .map((team) => (
                            <tr key={team.id}>
                              <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                                {team.name}
                              </td>
                              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                {team.members}
                              </td>
                              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                {team.lead}
                              </td>
                              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                {team.projects}
                              </td>
                              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                <span
                                  className={`inline-flex rounded-full ${
                                    team.status === "Active"
                                      ? "bg-green-600"
                                      : "bg-gray-600"
                                  } px-2 text-xs font-semibold leading-5 text-white`}
                                >
                                  {team.status}
                                </span>
                              </td>
                              {/* <td className="whitespace-nowrap px-6 py-4 text-right text-sm font-medium">
                            <div className="relative inline-block text-left">
                              <button
                                type="button"
                                className="flex items-center rounded-md bg-white text-gray-400 hover:text-gray-600 focus:outline-none"
                                id={`menu-button-${team.id}`}
                                aria-expanded="true"
                                aria-haspopup="true"
                              >
                                <span className="sr-only">Open options</span>
                                <MoreHorizontal className="h-5 w-5" />
                              </button>
                              <div
                                className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby={`menu-button-${team.id}`}
                              >
                                <div className="py-1" role="none">
                                  <button
                                    className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                    role="menuitem"
                                  >
                                    <Edit className="mr-3 h-4 w-4" />
                                    Edit Team
                                  </button>
                                  <button
                                    className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                    role="menuitem"
                                  >
                                    <UserPlus className="mr-3 h-4 w-4" />
                                    Manage Members
                                  </button>
                                  <button
                                    className="flex w-full items-center px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                                    role="menuitem"
                                  >
                                    <Trash className="mr-3 h-4 w-4" />
                                    Delete Team
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td> */}
                            </tr>
                          ))}
                      </>
                    ) : (
                      <tr>
                        <td
                          colSpan="5"
                          className="px-6 py-4 text-center text-sm text-gray-500 italic"
                        >
                          No teams found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        )}

        {activeTab === "members" && (
          <div className="overflow-hidden rounded-lg border border-gray-200 bg-white shadow-sm">
            <div className="border-b border-gray-200 px-6 py-4">
              <h3 className="text-lg font-semibold text-gray-900">
                Team Members
              </h3>
              <p className="text-sm text-gray-500">
                View and manage team members
              </p>
            </div>
            <div className="px-6 py-4">
              <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                  <thead className="bg-gray-50">
                    <tr>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        Name
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        Email
                      </th>
                      <th
                        scope="col"
                        className="px-6 py-3 text-left text-xs font-medium uppercase tracking-wider text-gray-500"
                      >
                        Joined
                      </th>
                    </tr>
                  </thead>
                  <tbody className="divide-y divide-gray-200 bg-white">
                    {employees?.length ? (
                      <>
                        {employees
                          ?.filter(
                            (member) =>
                              member.name
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase()) ||
                              member.email
                                .toLowerCase()
                                .includes(searchTerm.toLowerCase())
                          )
                          .map((member) => (
                            <tr key={member.id}>
                              <td className="whitespace-nowrap px-6 py-4 text-sm font-medium text-gray-900">
                                <div className="flex items-center">
                                  <div className="flex h-8 w-8 uppercase flex-shrink-0 items-center justify-center rounded-full bg-gray-200 text-sm font-medium text-gray-500">
                                    {member.name
                                      .split(" ")
                                      .map((n) => n[0])
                                      .join("")}
                                  </div>
                                  <div className="ml-3">
                                    <p className="font-medium">{member.name}</p>
                                  </div>
                                </div>
                              </td>
                              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                {member.email}
                              </td>
                              <td className="whitespace-nowrap px-6 py-4 text-sm text-gray-500">
                                {new Date(member.createdAt).toLocaleDateString(
                                  "en-GB"
                                )}
                              </td>
                              {/* <td className="whitespace-nowrap px-6 py-4 text-right text-sm font-medium">
                            <div className="relative inline-block text-left">
                              <button
                                type="button"
                                className="flex items-center rounded-md bg-white text-gray-400 hover:text-gray-600 focus:outline-none"
                                id={`menu-button-${member.id}`}
                                aria-expanded="true"
                                aria-haspopup="true"
                              >
                                <span className="sr-only">Open options</span>
                                <MoreHorizontal className="h-5 w-5" />
                              </button>
                              <div
                                className="absolute right-0 z-10 mt-2 w-56 origin-top-right rounded-md bg-white shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
                                role="menu"
                                aria-orientation="vertical"
                                aria-labelledby={`menu-button-${member.id}`}
                              >
                                <div className="py-1" role="none">
                                  <button
                                    className="flex w-full items-center px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
                                    role="menuitem"
                                  >
                                    <Edit className="mr-3 h-4 w-4" />
                                    Edit Member
                                  </button>
                                  <button
                                    className="flex w-full items-center px-4 py-2 text-sm text-red-600 hover:bg-gray-100"
                                    role="menuitem"
                                  >
                                    <Trash className="mr-3 h-4 w-4" />
                                    Remove Member
                                  </button>
                                </div>
                              </div>
                            </div>
                          </td> */}
                            </tr>
                          ))}
                      </>
                    ) : (
                      <tr>
                        <td
                          colSpan="3"
                          className="px-6 py-4 text-center text-sm text-gray-500 italic"
                        >
                          No member found.
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {/* <div className="border-t border-gray-200 px-6 py-4">
              <button className="inline-flex items-center rounded-md border border-transparent bg-red-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-red-700">
                <UserPlus className="mr-2 h-4 w-4" />
                Add Team Member
              </button>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
}
